import http from "./httpService";
import { TaxCase, TaxScenario, } from "../types/taxTypes";
import { ApiFile, IdType, } from "../types/appTypes";
import getApiEndpoint from "./apiEndpoint";
import { TaxFlow } from "../contexts/taxFlowStore";

const apiEndpoint = `${getApiEndpoint()}/taxCase`;

export function taxCaseUrl(id: string | number) {
  return `${apiEndpoint}/${id}`;
}



// GET|HEAD        api/v1/taxCase/{taxCase}/taxCaseScenario taxCase.taxCaseSce…
// POST            api/v1/taxCase/{taxCase}/taxCaseScenario taxCase.taxCaseSce…
// PUT|PATCH       api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario} …
// DELETE          api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario} …


// GET|HEAD        api/v1/taxCase/{taxCase}/taxCaseScenario taxCase.taxCaseSce…
export function getTaxScenarios(taxCaseId: IdType, isOptimization: boolean) {
  return http.get(getTaxScenariosUrl(taxCaseId, isOptimization))
}
export function getTaxScenariosUrl(taxCaseId: IdType, isOptimization: boolean) {
  return `${taxCaseUrl(taxCaseId)}/taxCaseScenario?filter[isOptimization]=${isOptimization ? 1 : 0}`
}

export type UpsertTaxScenarioPayload = {
  isOptimization?: boolean | null,
  skipFileCopy?: boolean | null;
  calculation: null | TaxFlow;
  caseFee: null | number;
  collateralFee: null | number;
  licensePlateFee: null | number;
  internalInfo?: string | null;
  externalInfo?: string | null;
  specialCaseFeeDiscount?: number | null;
  newPrice: null | {
    taxableValue: number | null,
    baseAmount: number | null,
    featuresAmount: number | null,
    total: number | null,
  }
  tradePrice: null | {
    calculated: number | null,
    estimated: number | null,
  },
  registrationFee: {
    total: number | null,
  }

}


// POST            api/v1/taxCase/{taxCase}/taxCaseScenario taxCase.taxCaseSce…
export function createTaxScenario(taxCaseId: IdType, data: UpsertTaxScenarioPayload) {
  return http.post<TaxCase>(`${taxCaseUrl(taxCaseId)}/taxCaseScenario`, data)
}

// PUT|PATCH       api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario} …
export function saveTaxScenario(taxCaseId: IdType, taxScenarioId: IdType, data: UpsertTaxScenarioPayload) {
  return http.put<TaxScenario>(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}`, data)
}

// DELETE          api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario} …
export function deleteTaxScenario(taxCaseId: IdType, taxScenarioId: string) {
  return http.delete(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}`)
}

// PUT|PATCH       api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/file/{file} taxCase.taxCaseScenario.file.update › TaxCase\ScenarioFileContr…

// POST            api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/file taxCase.taxCaseScenario.file.store › TaxCase\ScenarioFileController@…
export function uploadTaxScenarioFile(taxCaseId: IdType, taxScenarioId: IdType, formData: FormData) {
  return http.post<ApiFile>(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/file`, formData)
}
export function taxScenarioFileUrl(taxCaseId: IdType, taxScenarioId: IdType) {
  return `${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/file`
}

// DELETE          api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/file/{file} taxCase.taxCaseScenario.file.destroy › TaxCase\ScenarioFileContro…
export function deleteTaxScenarioFile(taxCaseId: IdType, taxScenarioId: IdType, fileId: string | number) {
  return http.delete(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/file/${fileId}`)
}






type GenerateDocumentationPayload = {
  files: {
    id: number | string;
  }[]
  motorAtlasFiles: {
    id: string;
  }[]
}
// POST            api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/documentation/generate taxCase.taxCaseScenario.documentation.generate › TaxCase\ScenarioDocumentationControlle…
export function generateDocumentation(taxCaseId: IdType, taxScenarioId: IdType, data: GenerateDocumentationPayload) {
  return http.post<TaxScenario>(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/documentation/generate`, data)
}
// POST            api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/documentation taxCase.taxCaseScenario.documentation.store › TaxCase\ScenarioDocumentationCo…
export function uploadDocumentationUrl(taxCaseId: IdType, taxScenarioId: IdType) {
  return `${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/documentation`
}
export function uploadDocumentation(taxCaseId: IdType, taxScenarioId: IdType, formData: FormData) {
  return http.post<ApiFile>(uploadDocumentationUrl(taxCaseId, taxScenarioId), formData)
}
// DELETE          api/v1/taxCase/{taxCase}/taxCaseScenario/{taxCaseScenario}/documentation/{documentation} taxCase.taxCaseScenario.documentation.destroy › TaxCase\ScenarioD…
export function deleteDocumentation(taxCaseId: IdType, taxScenarioId: IdType, documentId: number) {
  return http.delete(`${taxCaseUrl(taxCaseId)}/taxCaseScenario/${taxScenarioId}/documentation/${documentId}`)
}
